import { Box, Tooltip } from '@mantine/core';
import { Switch } from '@repo/foundations';

interface MonitorToggleProps {
	enabled: boolean;
	onChange: (enabled: boolean) => void;
	disabled?: boolean;
}

export function MonitorToggle({
	enabled,
	onChange,
	disabled = false,
}: MonitorToggleProps) {
	return (
		<Tooltip
			label={
				disabled
					? "You don't have permission to edit this monitor"
					: enabled
						? 'Monitor is active. Turning it off will pause scheduled runs.'
						: 'Monitor is paused. Turning it on will resume its scheduled runs.'
			}
		>
			<Box>
				<Switch
					checked={enabled}
					onChange={(event) => onChange(event.target.checked)}
					disabled={disabled}
				/>
			</Box>
		</Tooltip>
	);
}
